import { ReactNode } from 'react'

import styles from './styles.module.scss'

interface PageGridProps {
  aside: ReactNode;
  children: ReactNode;
}

export default function PageGrid (props: PageGridProps) {
  const { children, aside } = props

  return (
    <div className={styles.root}>
      {children}

      {aside}
    </div>
  )
}
